import { useRef, useState } from 'react';
import { Icon } from '@iconify/react';
import playIcon from '@iconify/icons-mdi/play';
import stopIcon from '@iconify/icons-mdi/stop';
// mdi:gauge-empty
import gaugeEmpty from '@iconify/icons-mdi/gauge-empty';
// mdi:gauge-low
import gaugeLow from '@iconify/icons-mdi/gauge-low';
// mdi:gauge-full
import gaugeFull from '@iconify/icons-mdi/gauge-full';

// material
import { MenuItem, ListItemIcon, ListItemText, Box, Fab, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import MenuPopover from '../MenuPopover';

// ----------------------------------------------------------------------

VolShareReplayVol.propTypes = {
  state: PropTypes.object,
  setState: PropTypes.func
};

export default function VolShareReplayVol({ state, setState }) {
  const ref = useRef(null);

  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Tooltip
        title={state.playVol ? 'Stop flight' : 'Replay flight'}
        ref={ref}
        onClick={() => (state.playVol ? setState({ ...state, playVol: false }) : setIsOpen(true))}
      >
        <Fab color="primary" sx={{ width: 45, height: 45 }}>
          <Icon icon={state.playVol ? stopIcon : playIcon} width={24} height={24} />
        </Fab>
      </Tooltip>

      <MenuPopover
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        sx={{ width: 200 }}
      >
        <Box>
          <MenuItem
            onClick={() => {
              setState({ ...state, speedReplay: 1, playVol: true });
              setIsOpen(false);
            }}
            sx={{ color: 'text.secondary' }}
          >
            <ListItemIcon key="speedx1">
              <Icon icon={gaugeEmpty} width={24} height={24} />
            </ListItemIcon>
            <ListItemText primary="Speed x1" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
          <MenuItem
            onClick={() => {
              setState({ ...state, speedReplay: 2, playVol: true });
              setIsOpen(false);
            }}
            sx={{ color: 'text.secondary' }}
          >
            <ListItemIcon key="speedx2">
              <Icon icon={gaugeLow} width={24} height={24} />
            </ListItemIcon>
            <ListItemText primary="Speed x2" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
          <MenuItem
            onClick={() => {
              setState({ ...state, speedReplay: 4, playVol: true });
              setIsOpen(false);
            }}
            sx={{ color: 'text.secondary' }}
          >
            <ListItemIcon key="speedx4">
              <Icon icon={gaugeFull} width={24} height={24} />
            </ListItemIcon>
            <ListItemText primary="Speed x4" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        </Box>
      </MenuPopover>
    </>
  );
}
